import { render, staticRenderFns } from "./ActCard.vue?vue&type=template&id=4c54e7e5&scoped=true"
import script from "./ActCard.vue?vue&type=script&lang=js"
export * from "./ActCard.vue?vue&type=script&lang=js"
import style0 from "./ActCard.vue?vue&type=style&index=0&id=4c54e7e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54e7e5",
  null
  
)

export default component.exports